<template>
  <div>
    <div id="FileViewer">
      <img class="center" :src="dataUrl" />
    </div>
    <div class="overlay"></div>
  </div>
</template>
  
</template>

<script>
export default {
    name: 'FileViewer',
    props: ['fileData'],
    components: {},
    data: () => ({}),
    computed: {
        dataUrl() {
            return 'data:image/jpeg;base64,' + btoa(new Uint8Array(this.fileData).reduce((data, byte) => data + String.fromCharCode(byte), ''));
        }
    },
    methods: {},
    mounted() {}
};
</script>
<style>
#FileViewer,
.overlay {
    position: absolute;
    top: 64px;
    bottom: 0;
    width: 100%;
}
#FileViewer {
    overflow: auto;
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    z-index: 203;
    -webkit-box-pack: center;
    -webkit-box-align: center;
}
.overlay {
    background-color: black;
    opacity: 0.7;
}
img.center {
    display: block;
    margin: 0 auto;
}
</style>
